import React, { useState, useEffect } from "react";
import PricingComparation from "./PricingComparation";
import { fetchPlan } from "./../api/userApi";
import { buyPackage } from "./../api/transactionApi";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ToastService from "./../services/ToastService";
import planData from "../data/planData";
import Modal3Js from "./Modal3Js";

const Pricing = () => {
  const navigate = useNavigate()
  const user = useSelector((state) => state.user.user);
  const [plan, setPlan] = useState();
  const [planSelected, setPlanSelected] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const fetchData = async () => {
    try {
      const data = await fetchPlan({ userId: user && user.guid });

      if (data) {
        setPlan(data.plan)
      }
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      console.log(error);
      ToastService.Error(error.response.data.message);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const upgradeToPlan = (plan) => {
    switch (plan) {
      case 'gold':
        checkLogin()
        break;
      case 'diamond':
        checkLogin()
        break;
      default:
        navigate('/')
        return;
    }
    setIsModalOpen(true)
    setPlanSelected(plan)
  }

  const PayPackage = async () => {
    try {
      const data = await buyPackage({ userId: user && user.guid, plan: planSelected });
      setIsModalOpen(false)
      ToastService.Success('Upgrade is sucessfully');
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    } catch (error) {
      setIsModalOpen(false)
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      console.log(error);
      ToastService.Error(error.response.data.message);

    }
  };

  const checkLogin = () => {
    if (!user) {
      navigate('/login')
      return;
    }
  }

  return (
    <>
      {
        isModalOpen && <Modal3Js
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title="🏆 Notification"
          submitText="Confirm"
          cancelText="Cancel"
        >

          <p>Are you sure want to buy this <span className="text-yellow-300 font-bold">"{planSelected.toUpperCase()}"</span> plan?
          </p>


          <div className="buttons">

            <div onClick={() => {
              PayPackage()
            }} data-router-disabled="" class="button is-purple">
              <span class="hover"></span>
              <span class="label">
                Checkout
              </span>
            </div>
            <button className="js-close button" onClick={() => {
              setIsModalOpen(false)
            }}>
              <span className="hover"></span>
              <span className="label">
                Close
              </span>
            </button>

          </div>
        </Modal3Js>
      }
      <PricingComparation />
      <section className="buy">
        <div className="buy-top">
          <div className="background"></div>
          <div className="section-title">
            Updated 100+ courses <br />
            <span className="highlight mt-4 mb-4 block">
              Game, Website (3D), Mobile, Cloud, Data Analysis
            </span>
          </div>
        </div>

        <div className="product">
          {

            planData && planData.map((item, index) => {
              return <>
                <div className="block mr-20 last:mr-0">
                  <div className="title">{item.planName}</div>

                  <div className="price">{item.price}</div>
                  <div className="details">{item.duration}</div>
                  <span className="separator"></span>
                  <ul className="features">
                    {
                      item.features.map((itemFeature, indexF) => {
                        return <li className="feature">
                          <span className="icon">
                            <svg
                              version="1.1"
                              id="Calque_1"
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              viewBox="0 0 9.9 9"
                            >
                              <path d="M5.3,8.4l4.3-6c0.5-0.7,0.4-1.6-0.3-2.1C8.6-0.2,7.7-0.1,7.2,0.6L3.8,5.3L2.4,4.1C1.8,3.6,0.8,3.7,0.3,4.3c-0.5,0.6-0.4,1.6,0.2,2.1l2.7,2.2C3.5,8.9,3.8,9,4.2,9h0.1C4.8,8.9,5.1,8.7,5.3,8.4z" />
                            </svg>
                          </span>{" "}
                          {itemFeature}
                        </li>
                      })
                    }
                  </ul>

                  {
                    plan && plan === item.plan ? (plan === 'silver' ? <Link
                      data-router-disabled
                      to={item.href}
                      className="button is-buy-join has-icon-right"
                    >
                      <span className="label">Courses</span>

                    </Link> : <div
                      data-router-disabled
                      className="button is-buy-join has-icon-right"
                    >
                      <span className="label">Current plan</span>

                    </div>) : <div
                      onClick={() => {
                        upgradeToPlan(item.plan)
                      }}
                      data-router-disabled
                      className="button is-buy-join has-icon-right"
                    >
                      <span className="label">{item.buttonText}</span>

                      {item.buttonIcon}
                    </div>
                  }

                </div>
              </>
            })
          }


        </div>
      </section>
    </>
  );
};

export default Pricing;
